<template>
    <div>
        <p>DEPRECATED!</p>
    </div>
</template>

<script>
import API from "@/api"
export default {
  name: 'ShipStation',
  mixins: [API],
    props: ['actions', 'data', 'isPlus', 'integrationId', 'integrations'],
    data() {
        return {
        }
    },

    methods: {
    },
}
</script>
<style lang="scss" scoped>

</style>
